import Fade from '@mui/material/Fade';
import Typography from "@mui/material/Typography";
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { useTranslation } from 'react-i18next';

import { useAssignedVideos } from './AssignedVideosContext';
import CustomLink from './CustomLink';

const paragraphStyles = {
    mb: 2,
    lineHeight: 1.8
}

const paperStyles = {
    padding: 2, 
    width: {
        xs: '100%',
        sm: '48%',
    },
    mb: 2,
    border: '2px solid rgb(91, 59, 140)',
    '&:hover': {
        boxShadow: '0px 4px 20px rgba(81, 80, 82, 0.8)',
        transform: 'scale(1.03)',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    }
}

const Portal = () => {
    const { t } = useTranslation();
    const { videosCount } = useAssignedVideos();
 
    return (
        <Fade in timeout={1000}>
            <div className="main">
                <Box sx={{ width: { xs: '100%', sm: '90%', md: '80%'}, margin: 'auto', padding: { xs: 2, sm: 4 }, textAlign: 'center' }}>
                    <Typography variant="h5" sx={{ mb: 2, fontWeight: '600' }}>{t("portal.title")}</Typography>
                    <Paper sx={{ 
                            ...paperStyles,
                            width: '100%',
                            mb: { xs: 2, sm: 4 }
                            }}>
                        <Typography variant="body1" sx={paragraphStyles}>{t("portal.paragraph_1")}</Typography>
                    </Paper>
                    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', mb: { xs: 2, sm: 4 } }}>
                        <Paper elevation={3} sx={paperStyles}>
                            <Typography variant="body1" sx={paragraphStyles}>{t("portal.paragraph_2")}</Typography>
                        </Paper>
                        <Paper elevation={3} sx={paperStyles}>
                            <Typography variant="body1" sx={paragraphStyles}>{t("portal.paragraph_3")}</Typography>
                        </Paper>
                    </Box>
                    <CustomLink to="/vaccine-info" linkText={t("portal.paragraph_4")} />
                </Box>
            </div>
        </Fade>
    )
}

export default Portal;